import { useState, useEffect } from 'react';
import { SunIcon, MoonIcon } from './Icons';
import { useAuth } from '../auth/AuthContext';

const headerStyles: React.CSSProperties = {
  backgroundColor: 'var(--surface-primary)',
  padding: '1rem 0',
  boxShadow: 'var(--shadow-md)',
  position: 'sticky',
  top: 0,
  zIndex: 10,
  flexShrink: 0,
};

const headerContainerStyles: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}

const logoTitleWrapperStyles: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.2rem',
};

const logoStyles: React.CSSProperties = {
  height: '40px'
};

const titleStyles: React.CSSProperties = {
  fontSize: '1.75rem',
  fontWeight: 800,
  margin: 0,
  background: 'var(--brand-gradient)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  letterSpacing: '-0.05em',
};

const controlsContainer: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
};

function Header() {
  const { session, logout } = useAuth();
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      return savedTheme;
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  });

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <header style={headerStyles}>
      <div className="container" style={headerContainerStyles}>
        <div style={logoTitleWrapperStyles}>
            <img src="/favicon.svg" style={logoStyles} alt="Sis Icon" />
            <h1 style={titleStyles}>SisOptimed</h1>
        </div>
        <div style={controlsContainer}>
            {session && (
              <button onClick={logout} className="btn btn-secondary">
                Sair
              </button>
            )}
            <button 
              onClick={toggleTheme} 
              className="btn-icon" 
              aria-label={`Mudar para tema ${theme === 'light' ? 'escuro' : 'claro'}`}
              title={`Mudar para tema ${theme === 'light' ? 'escuro' : 'claro'}`}
            >
              {theme === 'light' ? <MoonIcon /> : <SunIcon />}
            </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
